<template>
    <UModal title="Fakturavedlegg" :ui="{content: 'max-w-5xl'}">
        <UButton
            class="w-full @2xl:w-fit whitespace-nowrap"
            color="neutral"
            variant="outline"
            icon="i-ph-plus"
            :label="'Vedlegg' + (attachmentCount > 0 ? ` (${attachmentCount})` : '')"
        />
        <template #body>
            <FileUploader v-model="uploadedDocMetas" hide-desc @upload-success="onUploadSuccess"/>
            <div class="flex mt-2 w-full">
                <ul class="w-50 min-w-50 text-sm">
                    <li
                        v-for="docMeta in uploadedDocMetas"
                        :key="docMeta.uuid"
                        class="flex justify-between items-center"
                    >
                        <span class="grow truncate" :class="[selectedDocMetaUuid === docMeta.uuid ? 'font-bold' : 'cursor-pointer']" @click="selectedDocMetaUuid=docMeta.uuid">{{ docMeta.filename }}</span>
                        <UButton
                            size="sm"
                            variant="text"
                            color="error"
                            icon="i-ph-trash"
                            @click="removeAttachent(docMeta)"
                        />
                    </li>
                </ul>
                <DocumentPreview
                    v-if="selectedDocMetaUuid"
                    :document-meta-uuid="selectedDocMetaUuid"
                    class="mx-4"
                />
                <USkeleton v-else/>
            </div>
        </template>
    </UModal>
</template>

<script setup lang="ts">

import {useInvoiceCreator} from '@/invoice/invoice.service'
import {computed, ref} from 'vue'
import FileUploader from '@/document/FileUploader.vue'
import DocumentPreview from '@/document/DocumentPreview.vue'
import {DocumentMeta} from '@/types/transaction/DocumentMeta'

const {uploadedDocMetas} = useInvoiceCreator()

const attachmentCount = computed(() => uploadedDocMetas.value.length)
const selectedDocMetaUuid = ref('')

const onUploadSuccess = (newDocs: DocumentMeta[]) => {
    if (newDocs.length > 0) {
        selectedDocMetaUuid.value = newDocs[0].uuid
    }
}

const removeAttachent = (docMeta: DocumentMeta) => {
    uploadedDocMetas.value = uploadedDocMetas.value.filter(d => d.uuid !== docMeta.uuid)
}

</script>

<style scoped>

</style>